import { makeStyles } from '@policygenius/mortar';

export default makeStyles((theme) => ({
  footer: {
    backgroundColor: theme.colors.white,
    padding: `${theme.spacing('large')} 0`,
    [`@media (min-width: ${theme.breakpoints.medium}px)`]: {
      padding: `${theme.spacing('xlarge')} 0`,
    },
  },
  centeredRow: {
    margin: 'auto',
  },
  privacyCol: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    textAlign: 'center',
    border: 'none',
    marginBottom: theme.spacing('medium'),
    [`@media (min-width: ${theme.breakpoints.medium}px)`]: {
      borderRight: `1px solid ${theme.colors.gray200}`,
      marginBottom: 0,
    },
  },
  bbbCol: {
    display: 'flex',
    justifyContent: 'center',
  },
  questionsCol: {
    border: 'none',
    [`@media (min-width: ${theme.breakpoints.medium}px)`]: {
      borderRight: `1px solid ${theme.colors.gray200}`,
    },
  },
  centeredText: {
    textAlign: 'center',
    lineHeight: theme.spacing('large'),
  },
}));
